//====================================================
//  Function: Configurator steps
//====================================================
function fn_components_configuratorStepsScroll(){

	var scrollToSteps = true;
	if ($('.page-configurator-step-1').length){
		sessionStorage.setItem('stepsScroll', 'false');
	}

	if (sessionStorage.getItem("stepsScroll") !== null) {
		scrollToSteps = sessionStorage.getItem("stepsScroll");
	}

	if ($('.configurator-steps').length){
		if (scrollToSteps == 'true'){
			if ($window.width() > bp_small ){
				var navigationHeight = $('.navigation').height() + 30;
			} else {
				var navigationHeight = $('.navigation').height();
			}
			$( 'html, body' ).stop().delay(500).animate({
				scrollTop: $( '.configurator-steps' ).offset().top - navigationHeight
			}, 800);
		} else {
			sessionStorage.setItem('stepsScroll', 'true');
		}
	} 
}